import {useEffect} from 'react';
import {OSP_REDIRECT_KEY} from '../../../shared-deprecated/useGetOSPRedirectValue';
import {useAppUrlParams} from '../hooks/useAppUrlParams';

export const ForceAppRedirectListener = () => {
  const {device} = useAppUrlParams();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    const logo = document.getElementById('ay-logo');

    if (logo) {
      logo.addEventListener('click', function (event) {
        event.preventDefault();
      });
    }

    let timer: ReturnType<typeof setTimeout>;

    try {
      timer = setTimeout(function () {
        if (device && typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem(OSP_REDIRECT_KEY, device);
        }
      });
    } catch (e) {
      console.error(
        `Error setting "${OSP_REDIRECT_KEY}" sessionStorage value for force redirect to app`,
        e,
      );
    }

    return () => clearTimeout(timer);
  }, []);
  return null;
};
